const RouteConstants = {
    DASHBOARD: "/auth",
    COMPANIES: "/auth/companies",
    SCHOOLS: "/auth/schools",
    GROUPS: "/auth/roles",
    GROUP: "/auth/role",
    USERS: "/auth/users",
    STUDENTS: "/auth/students",
    INVOICES: "/auth/invoices",
    INVOICE_DELETION: "/auth/invoice_deletion",
    RECEIPTS: "/auth/receipts",
    VOUCHERS: "/auth/vouchers",
    JOURNALS: "/auth/journals",
    DEBIT_NOTES: "/auth/debit_notes",
    CREDIT_NOTES: "/auth/credit_notes",
    CSV_UPLOAD: "/auth/csv_upload",
    CHART_OF_ACCOUNTS: "/auth/chart_of_accounts",
    CONFIGURATIONS: "/auth/configurations",
    FORMS: "/auth/forms",
    DISCOUNTS: "/auth/discounts",
    REPORTS: "/auth/reports",
    DAILY_FEE_COLLECTION: "/auth/reports/daily_fee_collection",
    OUTSTANDING_FEES: "/auth/reports/outstanding_fees",
    MISSING_INVOICES: "/auth/reports/missing_invoices",
    OTHER_FEES_REPORT: "/auth/reports/other_fees_report"
};

export default RouteConstants;